import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import './ShortBreakInquiryModal.css';

const ShortBreakInquiryModal = ({ isOpen, onClose, shortBreak, showToast }) => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        travelDate: '',
        passengers: 1,
        notes: ''
    });
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        // Format notes field to include short break details
        const notesFormatted = `Package: ${shortBreak?.title || 'N/A'} | Duration: ${shortBreak?.duration || 'N/A'} | Notes: ${formData.notes || 'N/A'}`;

        const inquiryData = {
            type: 'shortbreak',
            name: formData.name,
            phone: formData.phone,
            email: formData.email,
            country: shortBreak?.destination || '',
            travel_date: formData.travelDate || null,
            passengers: parseInt(formData.passengers) || 1,
            notes: notesFormatted,
            status: 'new'
        };

        const { error } = await supabase.from('inquiries').insert([inquiryData]);

        setSubmitting(false);

        if (error) {
            console.error('Error submitting short break inquiry:', error);
            console.error('Error details:', JSON.stringify(error, null, 2));
            showToast?.(`Failed to submit inquiry: ${error.message || 'Please try again.'}`, 'error');
        } else {
            showToast?.('Short break inquiry submitted successfully! We will contact you soon.', 'success');
            setFormData({
                name: '',
                phone: '',
                email: '',
                travelDate: '',
                passengers: 1,
                notes: ''
            });
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="sb-modal-overlay" onClick={onClose}>
            <div className="sb-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="sb-modal-close" onClick={onClose}>
                    <i className="fa-solid fa-times"></i>
                </button>

                <div className="sb-modal-header">
                    <div className="sb-modal-icon">
                        <i className="fa-solid fa-calendar-days"></i>
                    </div>
                    <h2>Short Break Inquiry</h2>
                    <p className="sb-package-name">{shortBreak?.title}</p>
                    <div className="sb-package-details">
                        <span><i className="fa-solid fa-clock"></i> {shortBreak?.duration}</span>
                        <span><i className="fa-solid fa-location-dot"></i> {shortBreak?.destination}</span>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="sb-form">
                    <div className="sb-form-row">
                        <div className="sb-form-group">
                            <label>
                                <i className="fa-solid fa-user"></i> Full Name *
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter your name"
                                required
                            />
                        </div>

                        <div className="sb-form-group">
                            <label>
                                <i className="fa-solid fa-phone"></i> Phone Number *
                            </label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="+91 98765 43210"
                                required
                            />
                        </div>
                    </div>

                    <div className="sb-form-group">
                        <label>
                            <i className="fa-solid fa-envelope"></i> Email Address
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="your.email@example.com"
                        />
                    </div>

                    <div className="sb-form-row">
                        <div className="sb-form-group">
                            <label>
                                <i className="fa-solid fa-calendar"></i> Preferred Travel Date
                            </label>
                            <input
                                type="date"
                                name="travelDate"
                                value={formData.travelDate}
                                onChange={handleChange}
                                min={new Date().toISOString().split('T')[0]}
                            />
                        </div>

                        <div className="sb-form-group">
                            <label>
                                <i className="fa-solid fa-users"></i> Number of Travelers *
                            </label>
                            <input
                                type="number"
                                name="passengers"
                                value={formData.passengers}
                                onChange={handleChange}
                                min="1"
                                max="20"
                                required
                            />
                        </div>
                    </div>

                    <div className="sb-form-group">
                        <label>
                            <i className="fa-solid fa-comment"></i> Additional Requirements
                        </label>
                        <textarea
                            name="notes"
                            value={formData.notes}
                            onChange={handleChange}
                            placeholder="Any special requests or preferences..."
                            rows="3"
                        ></textarea>
                    </div>

                    <button type="submit" className="sb-submit-btn" disabled={submitting}>
                        {submitting ? (
                            <>
                                <i className="fa-solid fa-spinner fa-spin"></i>
                                Submitting...
                            </>
                        ) : (
                            <>
                                <i className="fa-solid fa-paper-plane"></i>
                                Submit Inquiry
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ShortBreakInquiryModal;
